import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./worker_gate.css";

/* ===== FIREBASE ===== */
import { db } from "../../firebase";
import { collection, query, where, getDocs, updateDoc, doc, limit } from "firebase/firestore";

/* ===== ASSETS ===== */
import bfLogo from "../../assets/bf_logo.png";

const WorkerGatePage = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Jei telefonas jau užregistruotas, siunčiame tiesiai į Biometriją
  useEffect(() => {
    const isRegistered = localStorage.getItem("workerDeviceRegistered");
    if (isRegistered === "true") {
      navigate("/worker/login", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async () => {
    // 1. SVARBU: Išvalome tarpus (telefonai dažnai prideda tarpą gale)
    const cleanCode = code.trim();

    // Tikriname kodo ilgį
    if (cleanCode.length < 4) {
      alert(t('enter_code_error') || "Please enter the security code");
      return;
    }

    setLoading(true);
    try {
      console.log("Tikrinamas kodas:", cleanCode); 

      // Ieškome darbuotojo, kurio kodas sutampa ir dar nebuvo panaudotas
      const q = query(
        collection(db, "workers"),
        where("loginCode", "==", cleanCode), // Naudojame cleanCode be tarpų
        where("codeUsed", "==", false),
        limit(1) 
      );

      const snap = await getDocs(q);

      if (snap.empty) {
        console.log("Kodas nerastas.");
        alert(t('invalid_code_error') || "Invalid or already used code. Please contact admin.");
        setLoading(false);
        return;
      }

      const workerDoc = snap.docs[0];
      const workerId = workerDoc.id;
      const workerData = workerDoc.data();

      // Atnaujiname įrašą bazėje (pažymime kodą kaip panaudotą)
      // Dabar tai veiks, nes pakeitėme Rules
      await updateDoc(doc(db, "workers", workerId), {
        codeUsed: true,
        lastRegistrationDate: new Date().toISOString()
      });

      // IŠSAUGOME DUOMENIS Į TELEFONO ATMINTĮ
      localStorage.setItem("workerId", workerId);
      localStorage.setItem("workerName", workerData.name);
      
      // masterAdminId yra kritinis, kad veiktų visi kiti puslapiai
      localStorage.setItem("masterAdminId", workerData.adminId); 
      
      // Žyma, kad įrenginis sėkmingai susietas
      localStorage.setItem("workerDeviceRegistered", "true");
      
      // Darbuotojas dar turi praeiti biometriją, kad pradėtų sesiją
      localStorage.setItem("workerGateDone", "false");

      // Nukreipiame į biometrinį prisijungimą
      navigate("/worker/login", { replace: true });

    } catch (err) {
      console.error("Gate Error:", err);
      // Grąžiname standartinį pranešimą (jau be techninės klaidos)
      alert(t('connection_error') || "Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="worker-gate-container">
      <div className="worker-gate-card blue-gate-aura">
        <div className="gate-branding">
          <div className="premium-logo-wrapper">
            <img src={bfLogo} alt="BF Logo" className="premium-logo-img" />
          </div>
          <h1 className="gate-app-name">BuildForce AL</h1>
        </div>

        <div className="gate-header-text">
          <h2 className="gate-title">{t('initial_setup') || "Initial Setup"}</h2>
          <p className="gate-subtitle">
            {t('gate_instruction') || "Enter the security code provided by your administrator to activate the system."}
          </p>
        </div>

        <div className="gate-form">
          <input
            className="gate-input"
            type="text"
            inputMode="numeric"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="— — — — — —"
            disabled={loading}
          />
          
          <button 
            className={`gate-submit-btn ${loading ? 'loading' : ''}`} 
            onClick={handleSubmit} 
            disabled={loading}
          >
            {loading ? t('verifying') : t('continue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkerGatePage;